














































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Location from "@/components/Communities/form/Location.vue";
import Description from "@/components/Communities/form/Description.vue";
import SocialContacts from "@/components/Communities/form/SocialContacts.vue";
import Topics from "@/components/Communities/form/Topics.vue";
import Leaders from "@/components/Communities/form/Leaders.vue";
import LogoUpload from "@/components/Communities/form/LogoUpload.vue";
import BannerUpload from "@/components/Communities/form/BannerUpload.vue";
import { formCheck } from "@/services/utils";
import ModalEdit from "@/components/ModalEdit.vue";
import CmBack from "@/components/CmBack.vue";

@Component({
    components: {
        Location,
        Description,
        SocialContacts,
        Topics,
        Leaders,
        LogoUpload,
        BannerUpload,
        ModalEdit,
        CmBack,
    },
    // mixins: [validationMixin],
    // validations: {
    //     formName: {
    //         required,
    //         minLength: minLength(3)
    //     }
    // }
})
export default class CreateCommunity extends Vue {
    public sent: boolean = false;
    public logo: boolean = false;
    public showUpdateResult: boolean = false;
    public updateResultMessage: string = "";
    public mustHaveProfile: boolean = false;
    public fileSizeError: boolean = false;
    public logoFile: any = undefined;
    public coverFile: any = undefined;
    public consent: boolean = false;
    public community: any = {
        name: "",
        description: "",
        basedIn: [],
        topics: [],
        social: {
            facebook: "",
            twitter: "",
            linkedin: "",
            mail: "",
            github: "",
        },
        logo: null,
        cover: null,
    };
    public errorsCheck: boolean = false;

    public formErrors: any = {
        logo: false,
        name: false,
        basedIn: false,
        topics: false,
        consent: false
    };

    public get profile() {
        return this.$store.getters.profile;
    }

    async mounted() {
        if (!this.hasProfileComplete) {
            this.mustHaveProfile = true;
        } else {
            this.community = await this.$communityApi.getCommunityEmpty();
        }
    }

    public goToProfile() {
        this.$router.push("profile");
    }

    public goBack() {
        this.$router.back();
    }

    public async communityCreate() {
        this.errorsCheck = false;
        if (!this.hasProfileComplete) {
            this.mustHaveProfile = true;
            return;
        }
        this.formErrors = formCheck(this.community, this.logo, this.consent);
        Object.values(this.formErrors).forEach((el) => {
            if (el) {
                this.errorsCheck = true;
                return;
            }
        });
        this.coverFile = (<any>this.$refs.croppa).$refs.croppa
            ? await (<any>this.$refs.croppa).$refs.croppa.promisedBlob(
                  "image/png",
                  0.8
              )
            : undefined;
        if (!this.errorsCheck) {
            const cid = await this.uploadCommunity(this.community);
            this.errorsCheck = false;
            this.sent = true;
        } else {
            this.errorsCheck = true;
            this.showUpdateResult = true;
        }
    }

    public async uploadCommunity(community) {
        try {
            const cid = await this.$communityApi.addCommunity(
                community,
                this.logoFile,
                this.coverFile || undefined
            );
            this.updateResultMessage = "Create complete with success!";
            return cid;
        } catch (error) {
            this.updateResultMessage = error.message;
        } finally {
            this.showUpdateResult = true;
        }
    }

    public loadLogo(file) {
        if (file) {
            if (file.size < 250000) {
                this.showUploadPreview(file, true);
                this.logoFile = file;
                this.logo = true;
            } else {
                this.fileSizeError = true;
            }
        }
    }

    public showUploadPreview(file, isLogo) {
        const reader = new FileReader();
        reader.onload = (e: any) =>
            isLogo
                ? (this.community.logo = e.target.result)
                : (this.community.cover = e.target.result);
        reader.readAsDataURL(file);
    }

    public get hasProfileComplete() {
        return this.profile.name !== "" && this.profile.name !== "";
    }

    @Watch("community.name")
    onCommunityNameChanged(val: string, oldval: string) {
        this.formErrors.name = false;
    }

    @Watch("community.logo")
    onCommunityLogoChanged(val: boolean, oldval: boolean) {
        this.formErrors.logo = false;
    }

    @Watch("community.basedIn")
    onCommunityBasedInChanged(val: any, oldval: any) {
        this.formErrors.basedIn = false;
    }

    @Watch("community.topics")
    onCommunityTopicsChanged(val: any, oldval: any) {
        this.formErrors.topics = false;
    }
}
